import React, { useState, useEffect } from 'react';

const MaintenanceBanner = () => {
  const [maintenanceSettings, setMaintenanceSettings] = useState(null);
  const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    const fetchMaintenanceSettings = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/site-settings/maintenance`);
        if (response.ok) {
          const data = await response.json();
          setMaintenanceSettings(data);
        }
      } catch (error) {
        console.error('Erreur chargement maintenance:', error);
      }
    };
    fetchMaintenanceSettings();
  }, [API_BASE_URL]);

  if (!maintenanceSettings?.enabled) return null;

  return (
    <div className="bg-gradient-to-r from-orange-500 to-amber-500 text-white py-6 px-4">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center">
        <img 
          src={maintenanceSettings.image_url || "https://static.prod-images.emergentagent.com/jobs/800848d0-1aa3-4e29-8992-42dce689cb56/images/30f8ad19d8fe0e7c65c19432aaf721e665fa9a8d0ade91ea2db4508df1efd96e.png"}
          alt="Maintenance"
          className="w-32 h-32 object-contain mb-4"
        />
        <h2 className="font-bold text-2xl mb-2">{maintenanceSettings.message || 'Site en maintenance'}</h2>
        <p className="text-white/90 text-base">Nous travaillons pour améliorer votre expérience. Merci de votre patience !</p>
      </div>
    </div>
  );
};

export default MaintenanceBanner;
